import React from 'react';

interface InvoiceStatusBadgeProps {
  status: 'draft' | 'sent' | 'viewed' | 'paid';
  className?: string;
}

export function InvoiceStatusBadge({ status, className = '' }: InvoiceStatusBadgeProps) {
  const getStatusConfig = () => {
    switch (status) {
      case 'paid':
        return {
          label: 'Paid',
          className: 'bg-green-100 text-green-700',
        };
      case 'sent':
        return {
          label: 'Sent',
          className: 'bg-blue-100 text-blue-700',
        };
      case 'viewed':
        return {
          label: 'Viewed',
          className: 'bg-purple-100 text-purple-700',
        };
      case 'draft':
        return {
          label: 'Draft',
          className: 'bg-gray-100 text-gray-700',
        };
      default:
        return {
          label: status,
          className: 'bg-gray-100 text-gray-700',
        };
    }
  };

  const config = getStatusConfig();

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
}
